import { useEffect } from 'react';
import { getBQMarketName } from 'api/stockPrice';
import { useStore } from 'stores';
import { getToken, getUser, clearSession } from 'utils/auth';

function useInit() {
  const setBQMarketName = useStore((state) => state.setBQMarketName);
  const setCurrentStock = useStore((state) => state.setCurrentStock);
  const login = useStore((state) => state.login);

  useEffect(() => {
    // Restore session if we have a stored JWT and user.
    const token = getToken();
    const user = getUser();
    if (token && user?.email) {
      login(user.email);
    }

    async function fetchMarkets() {
      if (!token) return; // BQMarketName is now login_required
      const res = await getBQMarketName();
      if (res && Array.isArray(res)) {
        setBQMarketName(res);
        setCurrentStock(res?.[0]);
      } else {
        // 401/403 cleared session — keep UI in logged-out state.
        clearSession();
      }
    }
    fetchMarkets();
  }, [setBQMarketName, setCurrentStock, login]);
}

export default useInit;
